export default function StormRoyaleIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#7B3FE4" />
      <circle cx="32" cy="34" r="22" fill="#5FBF4A" stroke="#FFFFFF" strokeWidth="3" strokeDasharray="6 4" />
      <rect x="14" y="18" width="6" height="22" rx="2" fill="#E0A86A" stroke="#7A4F25" strokeWidth="2" />
      <circle cx="40" cy="30" r="9" fill="#2F8BFF" stroke="#FFFFFF" strokeWidth="3" />
      <circle cx="43" cy="27" r="2.4" fill="#FFFFFF" />
      <rect x="44" y="34" width="14" height="6" rx="2" fill="#FFB020" stroke="#2B2F3A" strokeWidth="1.5" />
      <path d="M26 12l4-8 3 6 5-5-1 9" stroke="#FFD84D" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />
      <text x="32" y="58" textAnchor="middle" fontSize="11" fontWeight="900" fill="#FFD84D" fontFamily="sans-serif">#1</text>
    </svg>
  );
}
